import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconWhatsNew: React.FC<IconProps> = ({ color = 'var(--color-primary-2)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.515 0L0 3.01345V13.0174L7.5 16L15 13.0174V3.01438L7.515 0ZM13.3094 3.33341L11.0276 4.24091L5.24206 1.91229L7.51412 1.00105L13.3094 3.33341ZM7.5 5.64332L1.69324 3.33435L3.99529 2.41188L9.77559 4.73863L7.5 5.64332ZM0.882353 4.01169L7.05882 6.46755V14.824L0.882353 12.3681V4.01169ZM7.94118 14.824V6.46755L14.1176 4.01169V12.3681L7.94118 14.824Z"
                  fill={color}/>
        </svg>
    </div>
);

export default IconWhatsNew;